import { render, staticRenderFns } from "./Pharmacies.html?vue&type=template&id=6f5970ee&external"
import script from "./Pharmacies.js?vue&type=script&lang=js&external"
export * from "./Pharmacies.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports